module.exports = __webpack_public_path__ + "img/file_icon.f8d75566.jpg";